import React, {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from 'react';
import {
  useInvalidateAssignmentSession,
  usePatchAssignmentSessionCache,
  useRefreshAssignmentSession,
} from '../queries/useAssignmentChunks';

const TimeFilterContext = createContext();

export const useTimeFilter = () => {
  const context = useContext(TimeFilterContext);
  if (!context) {
    throw new Error('useTimeFilter must be used within a TimeFilterProvider');
  }
  return context;
};

/** Session selection only — pages read assignment data via React Query hooks, not context state. */
export const TimeFilterProvider = ({ children }) => {
  const [selectedResultId, setSelectedResultId] = useState(null);
  const publishSuccessRef = useRef(null);

  const invalidateAssignmentSession = useInvalidateAssignmentSession();
  const refreshAssignmentSession = useRefreshAssignmentSession();
  const patchAssignmentSessionCache = usePatchAssignmentSessionCache();

  const handleResultSelect = (resultId) => {
    setSelectedResultId(resultId || null);
  };

  const setOnPublishSuccess = useCallback((fn) => {
    publishSuccessRef.current = fn;
  }, []);

  const firePublishSuccess = useCallback((type) => {
    if (publishSuccessRef.current) publishSuccessRef.current(type);
  }, []);

  return (
    <TimeFilterContext.Provider
      value={{
        selectedResultId,
        handleResultSelect,
        setOnPublishSuccess,
        firePublishSuccess,
        invalidateAssignmentSession,
        refreshAssignmentSession,
        patchAssignmentSessionCache,
      }}
    >
      {children}
    </TimeFilterContext.Provider>
  );
};
